module.exports = __webpack_public_path__ + "img/taihu-logo.33477443.png";